export const styles = {
  searchContainer: {
    marginRight: '20px',
  },
  searchButton: {
    padding: '0px',
  },
  inputAdornment: {
    margin: 0,
    '& div': {
      display: 'flex',
    },
  },
  headerInput: {
    height: '36px !important',
    border: 'unset',
    borderRadius: '10px !important',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '146%',
    textAlign: 'start',
    color: '#23252F',
    backgroundColor: '#FAFBFC',
    '& fieldset': {
      border: 'none !important',
    },
  },
  searchIcon: {
    padding: '7px 12px',
  },
};
